import { create } from 'zustand';

import { ProcessMapState } from '@/types/ProcessMapState';

export const useProcessMapStore = create<ProcessMapState>()((set) => ({
  signs: [],

  actions: {
    addSigns: (newSigns) =>
      set(({ signs }) => ({
        signs: [...signs.filter(({ id }) => !newSigns.map((newSign) => newSign.id).includes(id)), ...newSigns],
      })),
    removeSign: (signId) =>
      set(({ signs }) => ({
        signs: signs.filter(({ id }) => id !== signId),
      })),
    reset: () => set({ signs: [] }),
  },
}));
